import { render, staticRenderFns } from "./tabMBL.vue?vue&type=template&id=a96b9530&scoped=true&"
import script from "./tabMBL.vue?vue&type=script&lang=js&"
export * from "./tabMBL.vue?vue&type=script&lang=js&"
import style0 from "./tabMBL.vue?vue&type=style&index=0&id=a96b9530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96b9530",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a96b9530')) {
      api.createRecord('a96b9530', component.options)
    } else {
      api.reload('a96b9530', component.options)
    }
    module.hot.accept("./tabMBL.vue?vue&type=template&id=a96b9530&scoped=true&", function () {
      api.rerender('a96b9530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL.vue"
export default component.exports